import { Model as t } from "../../../../model.js";
class d extends t {
  constructor(a) {
    super(), this.posType = a.posType, this.status = a.status, this.externalId = a.externalId, this.timestamp = a.timestamp, this.additionalData = a.additionalData;
  }
}
export {
  d as TicketHistoryPosModel
};
//# sourceMappingURL=ticketHistoryPos.model.js.map
